import { render, staticRenderFns } from "./RecorderDrawer.vue?vue&type=template&id=d938c7d4&scoped=true"
import script from "./RecorderDrawer.vue?vue&type=script&lang=ts"
export * from "./RecorderDrawer.vue?vue&type=script&lang=ts"
import style0 from "./RecorderDrawer.vue?vue&type=style&index=0&id=d938c7d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d938c7d4",
  null
  
)

export default component.exports